<script setup>
  /* global defineProps */
  import { computed } from 'vue'
  import { replayTtsSpeedAdjustment } from './replayLabels'

  const props = defineProps({
    output: { type: Object, default: null },
  })

  const warnings = computed(() =>
    Array.isArray(props.output?.qualityWarnings) ? props.output.qualityWarnings.filter(Boolean) : []
  )

  const speedAdjustment = computed(() => replayTtsSpeedAdjustment(props.output))

  const longestSilenceMs = computed(() =>
    warnings.value.reduce((longest, warning) => {
      const code = String(warning?.code || '')
      if (!code.includes('SILENCE') && !code.includes('SILENT')) return longest
      return Math.max(longest, Number(warning?.durationMs) || 0)
    }, 0)
  )

  const formatDuration = (milliseconds) => {
    const totalSeconds = Math.max(0, Math.round(Number(milliseconds) / 1000))
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    return hours
      ? `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      : `${minutes}:${String(seconds).padStart(2, '0')}`
  }

  const noticeText = computed(() => {
    if (!warnings.value.length) return ''
    const silence = longestSilenceMs.value ? `，最长静音约 ${formatDuration(longestSilenceMs.value)}` : ''
    return `当前版本包含 ${warnings.value.length} 项兼容处理${silence}。`
  })
</script>

<template>
  <div v-if="noticeText" class="quality-notice" role="note">
    <span aria-hidden="true">!</span>
    <div>
      <p v-if="speedAdjustment" class="speed-detail">{{ speedAdjustment.detail }}</p>
      <p>{{ noticeText }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .quality-notice {
    display: flex;
    margin-top: 12px;
    padding: 10px 12px;
    align-items: flex-start;
    color: #8a5d12;
    background: #fff8eb;
    border: 1px solid #f3d6a4;
    border-radius: 6px;
    font-size: 12px;
    line-height: 1.5;
    gap: 9px;

    span {
      display: grid;
      width: 17px;
      height: 17px;
      flex: none;
      place-items: center;
      color: #fff;
      background: #d97706;
      border-radius: 50%;
      font-size: 11px;
      font-weight: 700;
    }

    p {
      margin: 0;
    }

    .speed-detail {
      margin-bottom: 4px;
      font-weight: 600;
    }
  }
</style>
